import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
export const NotificationContainer = styled(Alert)`
  margin-top: 10px;
  word-break: break-word;
`;
export const Title = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;
const ErrorsList = styled.ul(
  ({ theme }) => `
  font-family: ${theme.fonts.family.monospace};
  list-style: initial;
  padding-left: 20px;
`
);
const ConnectionErrors = ({ errors, message = void 0 }) => {
  const { t } = useTranslation("authentication");
  return /* @__PURE__ */ React.createElement(NotificationContainer, { bsStyle: "danger", title: message != null ? message : t("connection_test.default_error") }, /* @__PURE__ */ React.createElement(ErrorsList, null, errors.map((error) => /* @__PURE__ */ React.createElement("li", { key: String(error) }, String(error)))));
};
export default ConnectionErrors;
